import { FACILITY_ROLE } from '../actionTypes'

// ** Initial State
const initialState = {
  data: [],
  total: 0,
  params: { limit: 10, offset: 0, q: '' },
  loading: false,
  error: null,
  success: null
}

const FacilityRoleReducer = (state = initialState, action) => {
  switch (action.type) {
    // List actions
    case FACILITY_ROLE.LIST_REQUEST:
      return Object.assign({}, state, { loading: true, error: null })
      
    case FACILITY_ROLE.LIST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: action.data,
        total: action.total,
        params: action.params || {},
        error: null
      })
      
    case FACILITY_ROLE.LIST_FAILURE:
      return Object.assign({}, state, { 
        loading: false, 
        data: [], 
        total: 0,
        error: action.error || 'Failed to load data'
      })
    
    // Create actions
    case FACILITY_ROLE.CREATE_REQUEST:
      return Object.assign({}, state, { 
        loading: true, 
        error: null, 
        success: null 
      })
      
    case FACILITY_ROLE.CREATE_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: [action.data].concat(state.data),
        total: state.total + 1,
        success: 'Successfully created',
        error: null
      })
      
    case FACILITY_ROLE.CREATE_FAILURE:
      return Object.assign({}, state, { 
        loading: false, 
        error: action.error,
        success: null
      })
    
    // Update actions
    case FACILITY_ROLE.UPDATE_REQUEST:
      return Object.assign({}, state, { 
        loading: true, 
        error: null, 
        success: null 
      })
      
    case FACILITY_ROLE.UPDATE_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: state.data.map(function(item) {
          return item.uuid === action.data.uuid ? action.data : item
        }),
        success: 'Successfully updated',
        error: null
      })
      
    case FACILITY_ROLE.UPDATE_FAILURE:
      return Object.assign({}, state, { 
        loading: false, 
        error: action.error,
        success: null
      })
    
    // Delete actions
    case FACILITY_ROLE.DELETE_REQUEST:
      return Object.assign({}, state, { 
        loading: true, 
        error: null, 
        success: null 
      })
      
    case FACILITY_ROLE.DELETE_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: state.data.filter(function(item) { 
          return item.uuid !== action.uuid 
        }),
        total: Math.max(0, state.total - 1),
        success: 'Successfully deleted',
        error: null
      })
      
    case FACILITY_ROLE.DELETE_FAILURE:
      return Object.assign({}, state, { 
        loading: false, 
        error: action.error,
        success: null
      })
    
    // Clear notification
    case FACILITY_ROLE.CLEAR_NOTIFY:
      return Object.assign({}, state, { 
        error: null, 
        success: null 
      })
    
    default:
      return state
  }
}

export default FacilityRoleReducer
